export const countries = [
  { key: '', value: '', text: '' },
  { key: 'US', flag: 'us', value: 'America', text: 'America' },
  { key: 'AR', flag: 'ar', value: 'Argentina', text: 'Argentina' },
  { key: 'AU', flag: 'au', value: 'Australia', text: 'Australia' },
  { key: 'AT', flag: 'at', value: 'Austria', text: 'Austria' },
  { key: 'BH', flag: 'bh', value: 'Bahrain', text: 'Bahrain' },
  { key: 'BE', flag: 'be', value: 'Belgium', text: 'Belgium' },
  { key: 'KH', flag: 'kh', value: 'Cambodia', text: 'Cambodia' },
  { key: 'CA', flag: 'ca', value: 'Canada', text: 'Canada' },
  { key: 'CN', flag: 'cn', value: 'China', text: 'China' },
  { key: 'CR', flag: 'cr', value: 'Czech-Republic', text: 'Czech Republic' },
  { key: 'DK', flag: 'dk', value: 'Denmark', text: 'Denmark' },
  { key: 'EN', flag: 'gb', value: 'England', text: 'England' },
  { key: 'EE', flag: 'ee', value: 'Estonia', text: 'Estonia' },
  { key: 'FI', flag: 'fi', value: 'Finland', text: 'Finland' },
  { key: 'FR', flag: 'fr', value: 'France', text: 'France' },
  { key: 'DE', flag: 'de', value: 'Germany', text: 'Germany' },
  { key: 'IN', flag: 'in', value: 'India', text: 'India' },
  { key: 'ID', flag: 'id', value: 'Indonesia', text: 'Indonesia' },
  { key: 'IT', flag: 'it', value: 'Italy', text: 'Italy' },
  { key: 'JP', flag: 'jp', value: 'Japan', text: 'Japan' },
  { key: 'JE', flag: 'gb', value: 'Jersey', text: 'Jersey' },
  { key: 'KW', flag: 'kw', value: 'Kuwait', text: 'Kuwait' },
  { key: 'LU', flag: 'lu', value: 'Luxembourg', text: 'Luxembourg' },
  { key: 'MY', flag: 'my', value: 'Malaysia', text: 'Malaysia' },
  { key: 'MM', flag: 'mm', value: 'Myanmar', text: 'Myanmar' },
  { key: 'NL', flag: 'nl', value: 'Netherlands', text: 'Netherlands' },
  { key: 'NZ', flag: 'nz', value: 'New Zealand', text: 'New Zealand' },
  { key: 'NO', flag: 'no', value: 'Norway', text: 'Norway' },
  { key: 'OM', flag: 'om', value: 'Oman', text: 'Oman' },
  { key: 'PT', flag: 'pt', value: 'Portugal', text: 'Portugal' },
  { key: 'PH', flag: 'ph', value: 'Phillipines', text: 'Phillipines' },
  { key: 'PL', flag: 'pl', value: 'Poland', text: 'Poland' },
  { key: 'RO', flag: 'ro', value: 'Romania', text: 'Romania' },
  { key: 'RU', flag: 'ru', value: 'Russia', text: 'Russia' },
  { key: 'QA', flag: 'qa', value: 'Qatar', text: 'Qatar' },
  { key: 'SA', flag: 'sa', value: 'Saudi Arabia', text: 'Saudi Arabia' },
  { key: 'SC', flag: 'gb sct', value: 'Scotland', text: 'Scotland' },
  { key: 'SG', flag: 'sg', value: 'Singapore', text: 'Singapore' },
  { key: 'SK', flag: 'sk', value: 'Slovakia', text: 'Slovakia' },
  { key: 'ZA', flag: 'za', value: 'South Africa', text: 'South Africa' },
  { key: 'KR', flag: 'kr', value: 'South Korea', text: 'South Korea' },
  { key: 'ES', flag: 'es', value: 'Spain', text: 'Spain' },
  { key: 'SE', flag: 'se', value: 'Sweden', text: 'Sweden' },
  { key: 'CH', flag: 'ch', value: 'Switzerland', text: 'Switzerland' },
  { key: 'TW', flag: 'tw', value: 'Taiwan', text: 'Taiwan' },
  { key: 'TH', flag: 'th', value: 'Thailand', text: 'Thailand' },
  {
    key: 'AE',
    flag: 'ae',
    value: 'United Arab Emirates',
    text: 'United Arab Emirates'
  },
  { key: 'VN', flag: 'vn', value: 'Vietnam', text: 'Vietnam' },
  { key: 'WA', flag: 'gb wls', value: 'Wales', text: 'Wales' }
];



// WEBPACK FOOTER //
// ./src/data/countries.data.js